import Vue from 'vue'
import Vuex from 'vuex'

//let properties = [{"id":9125,"realtor":"Bozeman Real Estate Group","host":"Bronson Neff","hostphone":"406.624.9788","email":"bronson@bozemanrealestate.group","mls":329737,"realtorurl":"http://www.bozemanrealestate.group","price":405000,"bedrooms":3,"baths":3,"description":"The model unit of South Rows will be open this Sunday from 12-3pm<br ,>These unique condominiums combine open and efficient floorplans, contemporary design, high-end finishes, big views, energy efficient components and euro-style windows that are sure to impress. This 3 bedroom, 3 bathroom condo features a 5kw solar package, spray foam insulation, all LED lighting throughout, energy star appliances, and high efficiency windows. The professionally designed finish package includes quartz counter tops, contemporary cabinets, solid core doors, matte black fixtures and hardware, LED back lit mirrors, Blomberg appliances, and SPC flooring. Unit #8 faces North with Bridger Mountain views over looking the large courtyard.","address":"544 ENTERPRISE BLVD BOZEMAN, MT","lat":45.648721,"long":-111.069073,"image":"https://kbzk.mapopenhouses.com/home_images/kbzk/20190409145055.jpg","houseurl":"https://southrows.com/","date":"2019-04-14","starttime":"12:00 pm","endtime":"3:00 pm","approved":1,"prints":0,"clicks":0},{"id":9126,"realtor":"Place Real Estate","host":"Diane Ingalls","hostphone":"406-600-1914","email":"diane@placemontana.com","mls":330609,"realtorurl":"http://www.placemontana.com","price":596500,"bedrooms":4,"baths":2.5,"description":"Attention to detail is evident throughout this beautiful home in coveted Flanders Mill. High ceilings showcase this quality built home. Truly a designer dream kitchen,  most of the living spaces on the main level with fourth bedroom upstairs perfect for guest space, playroom or office. Mountain views, close to so many amenities including new high school in 2020. ","address":"4130 SUNSTONE STREET BOZEMAN, MT","lat":45.687729,"long":-111.094499,"image":"https://kbzk.mapopenhouses.com/home_images/kbzk/20190409174632.jpg","houseurl":"www.placemontana.com","date":"2019-04-14","starttime":"1:00 pm","endtime":"3:00 pm","approved":1,"prints":0,"clicks":0},{"id":9127,"realtor":"Place Real Estate","host":"Diane Ingalls","hostphone":"406-600-1914","email":"diane@placemontana.com","mls":330609,"realtorurl":"http://www.placemontana.com","price":596500,"bedrooms":4,"baths":2.5,"description":"Attention to detail is evident throughout this beautiful home in coveted Flanders Mill. High ceilings showcase this quality built home. Truly a designer dream kitchen,  most of the living spaces on the main level with fourth bedroom upstairs perfect for guest space, playroom or office. Mountain views, close to so many amenities including new high school in 2020. ","address":"4130 SUNSTONE STREET BOZEMAN, MT","lat":45.687729,"long":-111.094499,"image":"https://kbzk.mapopenhouses.com/home_images/kbzk/20190409174632.jpg","houseurl":"http://www.placemontana.com","date":"2019-04-14","starttime":"1:00 pm","endtime":"3:00 pm","approved":0,"prints":0,"clicks":0}];
//let cities = [];
//let isAdmin = true;
//let siteName = 'KXLF';
//let siteTitle = '';
//let reportDate = '2019-04-10';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mapdrawer: true,
    properties: properties,
    isAdmin: isAdmin,
    siteTitle: siteTitle,
    siteName: siteName,
    cities: cities,
    reportDate: reportDate,
    propertyDTO: {
      mls: '',
      price: 0,
      bedrooms: 0,
      baths: 0,
      enddate: '',  //this field automatically set based on last date in datetimes array
      //need this so we can easily query firebase for all properties that have an endate >=
      //than current date... then locally we will display them based on being the same week as 
      //what is in array
      datetimes: [],
      address: '',
      urlOfProperty: '',
      image: '',
      description: '',
      user: '',
      approved: false,
    }
  },
  mutations: {
    set_mapdrawer: (state, data) => {
      state.mapdrawer = data;
    },
    set_properties: (state, data) => {
      state.properties = data;
    },
    set_isAdmin: (state, data) => {
      state.isAdmin = data;
    },
    set_siteTitle: (state, data) => {
      state.siteTitle = data;
    },
    set_siteName: (state, data) => {
      state.siteName = data;
    },
    set_cities: (state, data) => {
      state.cities = data;
    },
    set_reportDate: (state, data) => {
      state.reportDate = data;
    }
  },
  actions: {

  }
})
